'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class PregressBar extends Component {
  constructor(...args) {
    super(...args);
    this.setScoreAndStyle = scorePercentage => {
      const progressBarNode = findDOMNode(this.refs.progressBar);

      // Using setTimeout ensures the bar animates
      setTimeout(() => {
        // Set the width based on score
        progressBarNode.style.width = `${scorePercentage}%`;
      }, 1);
    };
  }
  componentDidMount() {
    this.setScoreAndStyle(this.props.scorePercentage);
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "bar-wrapper",
      children: [/*#__PURE__*/_jsx("div", {
        className: "bar"
      }), /*#__PURE__*/_jsx("div", {
        className: "bar progress-bar",
        ref: "progressBar"
      })]
    });
  }
}
PregressBar.propTypes = {
  scorePercentage: PropTypes.number.isRequired
};